<template>
    <v-container fluid fill-height>
        <v-layout align-space-around justify-start fill-height column>
          <v-layout row wrap class="mt-4 mb-4" justify-space-between>
            <v-flex xs12 sm12 md3>
              <h2 class="secondary--text mb-2">
                Pedidos
              </h2>
            </v-flex>
            <v-flex xs12 sm12 md8 v-show="activeFilter">
              <v-layout row wrap justify-space-around>
                <v-flex xs12 sm5>
                  <v-select
                    label="Status de entrega"
                    outline
                    v-model="status_entrega"
                    :items="[
                      {text: 'Todos', value: null},
                      {text: 'Pendente', value: 'pendente'},
                      {text: 'Em Trânsito', value: 'em_transito'},
                      {text: 'Entregue', value: 'entregue'}
                    ]"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    lazy
                    transition="slide-y-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Data prevista para entrega"
                        outline
                        v-model="data_entrega_prevista_formatada"
                        :loading="loading"
                        box
                        v-on="on"
                        required
                      >
                        <template v-slot:append>
                          <v-btn icon @click="data_entrega_prevista = ''" class="ma-0">
                            <v-icon color="primary">close</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data_entrega_prevista"
                      no-title
                      scrollable
                      color="primary"
                      locale="pt-br"
                      required
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md1>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :icon="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm"
                    :block="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
                    v-on="on"
                    @click="activeFilter = !activeFilter"
                    color="primary"
                  >
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                </template>
                <span>{{ activeFilter ? 'Fechar filtros' : 'Abrir filtros' }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
            <v-flex xs12>
              <v-data-table
                  hide-actions
                  :hide-headers="!pedidos.length"
                  :items="pedidos"
                  :pagination.sync="pagination"
                  :total-items="totalItens"
                  :loading="loading"
                  :headers="[
                      {
                          align: 'left',
                          sortable: false
                        },
                        {
                          text: 'ID',
                          align: 'left',
                          sortable: false,
                          value: 'id'
                        },
                          {
                          text: 'Status da entrega',
                          align: 'left',
                          sortable: false,
                          value: 'status_engrega'
                        },
                        {
                          text: 'Data prevista de entrega',
                          align: 'left',
                          sortable: false,
                          value: 'data_entrega_prevista'
                        },
                        {
                          text: 'Status de pagamento',
                          align: 'left',
                          sortable: false,
                          value: 'finalizado'
                        },
                        {
                          align: 'left',
                          sortable: false
                        }
                  ]"
              >
                  <v-alert v-slot:no-results :value="true" color="error" icon="warning">
                      Desculpe, não encontramos nenhum pedido!
                  </v-alert>
                  <template v-slot:items="props">
                      <tr>
                          <td>
                            <v-icon color="primary">receipt_long</v-icon>
                          </td>
                          <td>#{{ props.item.id }}</td>
                          <td>{{ props.item.status_entrega }}</td>
                          <td>
                            <span v-if="props.item.data_entrega_prevista">
                              {{ props.item.data_entrega_prevista | formatDate('DD/MM/YYYY') }}
                            </span>
                          </td>
                          <td>
                            {{ props.item.finalizado ? 'Sim' : 'Não' }}
                          </td>
                          <td>
                            <v-btn icon flat color="success" @click="pedidoSelecionado = props.item, dialogMudarStatusPedido = true">
                              <v-icon>{{ props.item.status_entrega === 'pendente' ? 'local_shipping' : 'check_circle' }}</v-icon>
                            </v-btn>
                            <v-btn icon flat color="priamry" @click="pedidoSelecionado = props.item, dialogVizualizarPedido = true">
                              <v-icon>visibility</v-icon>
                            </v-btn>
                          </td>
                      </tr>
                  </template>
              </v-data-table>
              <div class="text-xs-center" v-if="pages > 1">
                <v-pagination
                  v-model="pagination.page"
                  :length="pages"
                  circle
                ></v-pagination>
              </div>
            </v-flex>
        </v-layout>
        <dialog-mudar-status-pedido
          :active="dialogMudarStatusPedido"
          :pedido="pedidoSelecionado"
          @fechar="dialogMudarStatusPedido = false, pedidoSelecionado = undefined, carregarPedidos(false)"
        />
        <dialog-vizualizar-pedido
          :active="dialogVizualizarPedido"
          :pedido="pedidoSelecionado"
          @fechar="dialogVizualizarPedido = false, pedidoSelecionado = undefined"
        />
    </v-container>
</template>
<script>
import { VMoney } from 'v-money'
import DialogMudarStatusPedido from '@/components/dialogs/MudarStatusPedido'
import DialogVizualizarPedido from '@/components/dialogs/VizualizarPedido'

export default {
  directives: { money: VMoney },
  components: {
    DialogMudarStatusPedido,
    DialogVizualizarPedido
  },
  data: () => ({
    pedidos: [],
    menu: false,
    pedidoSelecionado: undefined,
    dialogMudarStatusPedido: false,
    dialogVizualizarPedido: false,
    activeFilter: false,
    status_entrega: null,
    totalItens: 0,
    data_entrega_prevista_formatada: undefined,
    data_entrega_prevista: undefined,
    pagination: {
      page: 1,
      rowsPerPage: 10
    }
  }),
  computed: {
    empresa () {
      return this.$store.getters.empresa
    },
    frentista () {
      return this.$store.getters.frentista
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      let count = this.totalItens
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    }
  },
  watch: {
    pagination: {
      handler () {
        if (this.frentista) this.carregarPedidos(false)
      },
      deep: true
    },
    data_entrega_prevista (val) {
      this.menu = false
      if (val) {
        this.formatDate(val)
      } else {
        this.data_entrega_prevista_formatada = undefined
      }
      if (this.frentista && this.activeFilter) this.carregarPedidos(true)
    },
    frentista (val) {
      if (val) this.carregarPedidos(false)
    },
    status_entrega (val) {
      if (this.frentista && this.activeFilter) this.carregarPedidos(true)
    }
  },
  mounted () {
    if (this.frentista) this.carregarPedidos(false)
  },
  methods: {
    formatDate (date) {
      this.data_entrega_prevista_formatada = date
        .split('-')
        .reverse()
        .join('/')
    },
    carregarPedidos (btn) {
      const data = {
        method: 'GET',
        parametros: {
          empresa: this.empresa ? this.empresa.cnpj : null,
          id_frentista: this.frentista ? this.frentista.id_frentista : null,
          page: btn ? 1 : this.pagination.page,
          page_size: this.pagination.rowsPerPage
        }
      }
      if (this.activeFilter) {
        if (this.status_entrega !== null) data.parametros.status_entrega = this.status_entrega
        if (this.data_entrega_prevista) data.parametros.data_entrega_prevista = this.data_entrega_prevista
      }
      this.$store.dispatch('pedidosMultiMethods', data).then(json => {
        this.pedidos = json.results
        this.totalItens = json.count
      })
    }
  }
}
</script>
